import React from "react";
import { BarChart, Bar, XAxis, ResponsiveContainer, Cell } from "recharts";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { CARD } from "@/styles/shared";

const DASH_CARD = {
  ...CARD,
  background: "rgba(255,255,255,0.82)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  border: "1px solid rgba(255,255,255,0.7)",
};

const CHART_MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };

export default function WeeklyProgress({ stats }) {
  if (!stats) return null;
  const { this_week, last_week, trend, bars } = stats;

  const diff = this_week - last_week;
  const TrendIcon = trend === "up" ? TrendingUp : trend === "down" ? TrendingDown : Minus;
  const trendColor = trend === "up" ? "#16a34a" : trend === "down" ? "#dc2626" : "#6b7280";

  const diffLabel = diff === 0
    ? `Same as last week (${last_week})`
    : `${Math.abs(diff)} ${diff > 0 ? "more than" : "fewer than"} last week (${last_week})`;

  return (
    <div style={{ ...DASH_CARD, overflow: "hidden" }}>
      <div style={{
        padding: "0.875rem 1.25rem",
        borderBottom: "1px solid rgba(26,77,46,0.1)",
        display: "flex", alignItems: "center", gap: "0.5rem",
      }}>
        <TrendIcon size={16} color={trendColor} />
        <span style={{ fontFamily: "'Manrope', sans-serif", color: "#1A4D2E", fontSize: "0.95rem", fontWeight: 700 }}>
          Weekly Progress
        </span>
      </div>

      <div style={{ padding: "1rem 1.25rem 1.25rem" }}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: "0.5rem", marginBottom: "0.2rem" }}>
          <span style={{
            fontFamily: "'Manrope', sans-serif", fontSize: "2.5rem",
            fontWeight: 800, color: "#1A4D2E", lineHeight: 1,
          }}>
            {this_week}
          </span>
          <span style={{
            fontFamily: "'Manrope', sans-serif", color: "#6b7280",
            fontSize: "0.82rem", paddingBottom: "0.35rem",
          }}>
            tasks this week
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.3rem", marginBottom: "1.1rem" }}>
          <TrendIcon size={13} color={trendColor} />
          <span style={{
            fontFamily: "'Manrope', sans-serif", fontSize: "0.76rem",
            color: trendColor, fontWeight: 600,
          }}>
            {diffLabel}
          </span>
        </div>

        <div style={{ height: "80px", minHeight: "80px", minWidth: "1px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={bars} barCategoryGap="25%" margin={CHART_MARGIN}>
              <XAxis
                dataKey="day"
                tick={{ fontFamily: "'Manrope', sans-serif", fontSize: 11, fill: "#9ca3af" }}
                axisLine={false}
                tickLine={false}
              />
              <Bar dataKey="count" radius={[3, 3, 0, 0]}>
                {bars.map((entry) => (
                  <Cell key={entry.date} fill={entry.count > 0 ? "#3d6b1f" : "rgba(26,77,46,0.1)"} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
